module.exports = __webpack_public_path__ + "img/ordered-list.36d74754.svg";